"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _libphonenumberJs = require("libphonenumber-js");

var _uiKit = require("@devsta/ui-kit");

var _getUserFullName = _interopRequireDefault(require("@devsta/get-user-full-name"));

require("../styles/_user-details.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function UserDetails(_ref) {
  var user = _ref.user,
      invitedEmail = _ref.email;

  var _ref2 = user || {},
      imageUrl = _ref2.imageUrl,
      email = _ref2.email,
      phoneNumber = _ref2.phoneNumber,
      officeLocation = _ref2.officeLocation;

  var userName = (0, _getUserFullName.default)(user);
  var number = phoneNumber ? (0, _libphonenumberJs.parsePhoneNumberFromString)(phoneNumber).format('NATIONAL') : '';
  return _react.default.createElement("div", {
    className: "user-details"
  }, _react.default.createElement(_uiKit.Image, {
    imageUrl: imageUrl,
    placeholderText: userName,
    placeholderTextSize: 13,
    width: "40px",
    height: "40px",
    defaultImageIcon: "user",
    circular: true,
    backgroundSize: "cover"
  }), _react.default.createElement("div", {
    className: "user-details__text__container"
  }, _react.default.createElement("p", {
    className: "user-details__text__container__name"
  }, _react.default.createElement("strong", null, userName)), _react.default.createElement("span", {
    className: "user-details__text__container__office"
  }, officeLocation || '-'), _react.default.createElement("div", {
    className: "user-details__text__contact-info"
  }, _react.default.createElement("strong", null, email || invitedEmail || '-'), _react.default.createElement("strong", null, number || '-'))));
}

var _default = (0, _react.memo)(UserDetails);

exports.default = _default;